import { defineStore } from "pinia";
import { services, getHeader } from '@/assets/js/config.js'
import axios from "axios";
import { useAuthStore } from '@/stores/authStore'

export const useNotificationStore = defineStore('notificationStore', {
	state: () => ({
		notifications: [],
		emailTemplateData: null, // Renamed state property
		setupTemplateData: null, // Renamed state property
	}),
	getters: {
		navbar_notifications(state) {
			let maxCount = 8
			let notifications = []
			for (let i = 0; i <= state.notifications.length; i++) {
				const notification = state.notifications[i]
				if (notification && i < maxCount) {
					notifications.push(notification)
				}
			}
			return notifications
		},
		unread_notifications(state) {
			return state.notifications.filter((item) => item.noti_read_at === null)
		},
		emailTemplate(state) { // Getter with the same name as the state property should be removed or renamed
			return state.emailTemplateData;
		},
		setupTemplate(state) { // Getter with the same name as the state property should be removed or renamed
			return state.setupTemplateData;
		},
	},
	actions: {
		async saveEmail(payload) {
			try {

				const response = await axios.post(
					services.notification + "notif-template",
					payload,
					{ headers: getHeader() }
				);
				console.log("Data saved successfully.");
				this.form.notif_temp_id = response.data.notif_temp_id; // Store the id after saving
			} catch (e) {
				console.log("Failed to save data:", e.response ? e.response.data.message : e.message);
				console.log("Failed to save data.");
			}
		},

		async updateEmail(payload) {
			try {
				const notif_temp_id = payload.notif_temp_id;

				await axios.put(
					services.notification + "notif-template/" + notif_temp_id,

					payload,
					{ headers: getHeader() }
				);
				console.log("Data updated successfully.");
			} catch (e) {
				console.error("Failed to update data:", e.response ? e.response.data.message : e.message);
			}
		},
		async saveNotification(payload) {
			try {

				const response = await axios.post(
					services.notification + "notif-template",
					payload,
					{ headers: getHeader() }
				);
				console.log("Data saved successfully.");
				this.form.notif_temp_id = response.data.notif_temp_id; // Store the id after saving
			} catch (e) {
				console.log("Failed to save data:", e.response ? e.response.data.message : e.message);
				console.log("Failed to save data.");
			}
		},

		async updateNotification(payload) {
			try {
				const notif_temp_id = payload.notif_temp_id;

				await axios.put(
					services.notification + "notif-template/" + notif_temp_id,

					payload,
					{ headers: getHeader() }
				);
				console.log("Data updated successfully.");
			} catch (e) {
				console.error("Failed to update data:", e.response ? e.response.data.message : e.message);
			}
		},
		async getUserNotifications() {
			try {
				const user_id = useAuthStore().auth_user.id
				const res = await axios.get(services.notification + 'notifications?noti_user_id=' + user_id, { headers: getHeader() })
				this.notifications = res.data.data
			} catch (e) {
				console.log('Notification Store (getNotifications) failed:' + e.response.data.message)
			}
		},
		async markAsRead(notification) {
			if (!notification.noti_read_at) {
				try {
					const res = await axios.put(services.notification + 'notifications/' + notification.noti_id, null, { headers: getHeader() })
					this.getUserNotifications()
				} catch (e) {
					console.log('Notification Store (getNotifications) failed:' + e.response.data.message)
				}
			}
		},
		async markAllAsRead() {
			if (this.notifications.length > 0) {
				try {
					const notification = this.notifications[0]
					const res = await axios.put(services.notification + 'notifications/' + notification.noti_id + '?mark_all=true', null, { headers: getHeader() })
					this.getUserNotifications()
				} catch (e) {
					console.log('Notification Store (getNotifications) failed:' + e.response.data.message)
				}
			}
		},
		async createNotification(data) {
			try {
				const res = await axios.post(services.notification + 'notifications', data, { headers: getHeader() })
			} catch (e) {
				console.log('Notification Store (createNotification) failed:' + e.response.data.message)
				throw e
			}
		},
		async fetchEmailTemplate(triggerPoint) {
			try {
				const emailResponse = await axios.get(
					services.notification + "notif-template/details",
					{
						params: {
							trigger_point: triggerPoint,
							notif_temp_type: 'email',
						},
						headers: getHeader()
					}
				);
				return emailResponse.data;
				console.log(emailResponse.data);
			} catch (error) {
				console.error('Failed to fetch email template:', error);
				return null;
			}
		},
		async fetchNotificationTemplate(triggerPoint) {
			try {
				const emailResponse = await axios.get(
					services.notification + "notif-template/details",
					{
						params: {
							trigger_point: triggerPoint,
							notif_temp_type: 'bell',
						},
						headers: getHeader()
					}
				);
				return emailResponse.data;
				console.log(emailResponse.data);
			} catch (error) {
				console.error('Failed to fetch notification template:', error);
				return null;
			}
		},
		getTemplates(params={}) {
			return new Promise((resolve, reject) => {
				let queryParams = _gHlp.generateQueryParams(params)
				axios.get(services.notification + 'notif-templates?' + queryParams, { headers: getHeader() })
					.then(res => {
						resolve(_gHlp.getValue(res,'data',[]));
					})
					.catch(e => {
						_gNotif.errorFunction(e)
						reject(e)
					})
			});
		},
		createTemplate(params) {
			return new Promise((resolve, reject) => {
				axios.post(services.notification + 'notif-template',params, { headers: getHeader() })
					.then(res => {
						resolve(res);
					})
					.catch(e => {
						_gNotif.errorFunction(e)
						reject(e)
					})
			});
		},
		updateTemplate(id,params={}) {
			return new Promise((resolve, reject) => {
				axios.put(services.notification + 'notif-template/'+id, params, { headers: getHeader() })
					.then(res => {
						resolve(res);
					})
					.catch(e => {
						_gNotif.errorFunction(e)
						reject(e)
					})
			});
		},
		deleteTemplate(id) {
			return new Promise((resolve, reject) => {
				axios.delete(services.notification + 'notif-template/'+id, { headers: getHeader() })
					.then(res => {
						resolve(res);
					})
					.catch(e => {
						_gNotif.errorFunction(e)
						reject(e)
					})
			});
		},
	}
})